<div class="login" fxLayout="column">
    <ng-container *ngIf="accessMode === 'login'">
        <div class="slide-head" fxLayoutAlign="start center" fxLayout.lt-md="row" fxLayoutGap="5px">
            <mat-icon>login</mat-icon>
            <div i18n>Login</div>
        </div>

        <app-login-form (onLoginSuccess)="onLoginOrSignup.emit(true)"></app-login-form>
        <p *ngIf="customerLanding.enable_anonymous_register" class="pointer red mt-0 register">
            <strong>
                <span class="pointer mt-0 red" i18n (click)="accessMode = 'signup'"> Create account </span>
            </strong>
        </p>
    </ng-container>
    <ng-container *ngIf="accessMode === 'signup'">
        <div class="slide-head" fxLayoutAlign="start center" fxLayout.lt-md="row" fxLayoutGap="5px">
            <mat-icon>how_to_reg</mat-icon>
            <div i18n>Signup</div>
        </div>
        <app-signup-form (onSignupSuccess)="onLoginOrSignup.emit(true)"></app-signup-form>
        <p *ngIf="customerLanding.enable_anonymous_register" class="pointer red mt-0 register">
            <strong>
                <span class="pointer mt-0 red" i18n (click)="accessMode = 'login'"> Already has account </span>
            </strong>
        </p>
    </ng-container>
</div>
